import React from "react";
import { useTranslation } from "react-i18next";
import useSkin from "../../hooks/useSkin";
import { DashboardClassTypes } from "../../redux/actions/dashboard/types";
import { StyledClassGlance, StyledClassCard } from "./Dashboard.styles";

interface Props {
  classes: DashboardClassTypes[];
  onClassClick: (groupId: number) => void;
}

const ClassAtGlance: React.FC<Props> = ({ classes, onClassClick }) => {
  const { t } = useTranslation();
  const { isGriffle } = useSkin();

  if (!classes?.length) {
    return null;
  }

  const getTotalStudents = (cls: DashboardClassTypes): number => {
    return (cls.readingLevelStats ?? []).reduce((sum, stat) => sum + (stat?.numberOfStudents ?? 0), 0);
  };

  return (
    <StyledClassGlance $isGriffle={isGriffle}>
      <h2 className="glance-title">{t("dashboard_class_glance_title", "Classes at a Glance")}</h2>

      <div className="glance-grid">
        {classes.map((cls) => (
          <StyledClassCard key={cls.groupId} $isGriffle={isGriffle} onClick={() => onClassClick(cls.groupId)}>
            <p className="class-name">
              {t("dashboard_page_class", "Class")} {cls.className}
            </p>
            <div className="class-stat">
              <span>{t("dashboard_class_glance_students", "Students")}</span>
              <span className="class-stat-value">{getTotalStudents(cls)}</span>
            </div>
            <div className="class-stat">
              <span>{t("dashboard_class_glance_levels", "Reading levels")}</span>
              <span className="class-stat-value">{(cls.readingLevelStats ?? []).length}</span>
            </div>
          </StyledClassCard>
        ))}
      </div>
    </StyledClassGlance>
  );
};

export default ClassAtGlance;
